import React from 'react';







export function getDateString(date) {
  try {
    let datex = new Date(date);
    let day = '';
    const year = datex.getFullYear();
    let month = '';
    if (datex.getMonth() + 1 < 10) {
      month = '0' + (datex.getMonth() + 1);
    } else {
      month = datex.getMonth() + 1;
    }
    if (datex.getDate() < 10) {
      day = '0' + datex.getDate();
    } else {
      day = datex.getDate();
    }

    const dateStr = day + '/' + month + '/' + year;
    return dateStr;
  } catch (e) {
    console.log(e);
  }
}

export function getTimeString(date) {
  let hours = date.getHours();
  let minutes = date.getMinutes();
  const ampm = hours >= 12 ? 'pm' : 'am';
  hours = hours % 12;
  hours = hours ? hours : 12; // the hour '0' should be '12'
  minutes = minutes < 10 ? '0' + minutes : minutes;
  const strTime = hours + ':' + minutes + ' ' + ampm;
  return strTime;
}

export function getGreetingTime(m) {
  var g = null; //return g

  if (!m || !m.isValid()) {
    return;
  } //if we can't find a valid or filled moment, we return.

  var split_afternoon = 12; //24hr time to split the afternoon
  var split_evening = 17; //24hr time to split the evening
  var currentHour = parseFloat(m.format('HH'));

  if (currentHour >= split_afternoon && currentHour <= split_evening) {
    g = 'Afternoon';
  } else if (currentHour >= split_evening) {
    g = 'Evening';
  } else {
    g = 'Morning';
  }

  return g;
}


// TO FORCE THE COMPONENT TO UPDATE, TO GET THE STATE RESULT 
export const useForceUpdate = () => {
  const [, updateState] = React.useState();
  return React.useCallback(() => updateState({}), []);
}

//  CAPATILIAZE THE FIRST LETTER OF STRING
export const capitalizeFirstLetter = (str) => {
  if (!str) return;
  return str?.charAt(0)?.toUpperCase() + str.slice(1);
};



// VALIDATING EMAIL
export function validateEmail(text) {
  let reg = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;
  if (reg.test(text) === false) return false;
  else return true;
}


export function getTimeAgo(date) {
  const MINUTE = 60 * 1000; // milliseconds in a minute
  const HOUR = 60 * MINUTE; // milliseconds in an hour
  const DAY = 24 * HOUR; // milliseconds in a day
  const WEEK = 7 * DAY; // milliseconds in a week
  const MONTH = 30 * DAY; // approximate milliseconds in a month
  const YEAR = 365 * DAY; // approximate milliseconds in a year

  const currentTime = new Date().getTime();
  const pastTime = new Date(date).getTime();
  const timeDiff = currentTime - pastTime;

  if (timeDiff < MINUTE) {
    return 'just now';
  } else if (timeDiff < HOUR) {
    const minutes = Math.floor(timeDiff / MINUTE);
    return `${minutes} minute${minutes > 1 ? 's' : ''} ago`;
  } else if (timeDiff < DAY) {
    const hours = Math.floor(timeDiff / HOUR);
    return `${hours} hour${hours > 1 ? 's' : ''} ago`;
  } else if (timeDiff < WEEK) {
    const days = Math.floor(timeDiff / DAY);
    return `${days} day${days > 1 ? 's' : ''} ago`;
  } else if (timeDiff < MONTH) {
    const weeks = Math.floor(timeDiff / WEEK);
    return `${weeks} week${weeks > 1 ? 's' : ''} ago`;
  } else if (timeDiff < YEAR) {
    const months = Math.floor(timeDiff / MONTH);
    return `${months} month${months > 1 ? 's' : ''} ago`;
  } else {
    const years = Math.floor(timeDiff / YEAR);
    return `${years} year${years > 1 ? 's' : ''} ago`;
  }
}


export function yyyymmdd(dateObj) {
  let date = new Date(dateObj)
  let day = date.getDate(); // Get the day as a number (1-31)
  let month = date.getMonth() + 1; // Get the month as a number (0-11), add 1 because getMonth() returns 0-11
  let year = date.getFullYear(); // Get the 4-digit year

  // Add leading zeros to day and month if necessary
  day = day < 10 ? '0' + day : day;
  month = month < 10 ? '0' + month : month;

  // Concatenate in dd/mm/yyyy format
  return day + '-' + month + '-' + year;
}


